export const SELECTED_LAYOUT = 'SELECTED_LAYOUT'
